import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2479 18.1638L20.8479 7.56384C20.8948 7.51736 20.932 7.46206 20.9573 7.40113C20.9827 7.3402 20.9958 7.27484 20.9958 7.20884C20.9958 7.14283 20.9827 7.07748 20.9573 7.01655C20.932 6.95562 20.8948 6.90032 20.8479 6.85384L20.1479 6.14384C20.0527 6.05159 19.9254 6 19.7929 6C19.6604 6 19.533 6.05159 19.4379 6.14384L9.8879 15.6938L5.5579 11.3638C5.51142 11.317 5.45612 11.2798 5.39519 11.2544C5.33426 11.229 5.2689 11.2159 5.2029 11.2159C5.13689 11.2159 5.07154 11.229 5.01061 11.2544C4.94968 11.2798 4.89438 11.317 4.8479 11.3638L4.1479 12.0638C4.10103 12.1103 4.06384 12.1656 4.03845 12.2265C4.01307 12.2875 4 12.3528 4 12.4188C4 12.4848 4.01307 12.5502 4.03845 12.6111C4.06384 12.6721 4.10103 12.7274 4.1479 12.7738L9.5379 18.1638C9.58438 18.2107 9.63968 18.2479 9.70061 18.2733C9.76154 18.2987 9.82689 18.3117 9.8929 18.3117C9.95891 18.3117 10.0243 18.2987 10.0852 18.2733C10.1461 18.2479 10.2014 18.2107 10.2479 18.1638Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgVOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgVOutline;
